// Generated by ts-to-zod
import {z} from "@AppBuilderLib/shared/lib/zod";
import {mantineStylesApiSchema} from "./primitives.zod";

export const mantineAccordionPropsSchema = z.strictObject({
	styles: mantineStylesApiSchema.optional(),
});
